export interface ComparisonRow {
  without: string
  with: string
}
export const comparisonRows: ComparisonRow[] = [
  {
    without: 'Ponad 100 godzin rocznie na planowanie',
    with: '10 minut tygodniowo · Wszystko gotowe',
  },
  {
    without: 'Improwizowane lekcje · Brak progresji',
    with: '50 gotowych ćwiczeń + teoria · Logiczna progresja',
  },
  {
    without: 'Postępy uczniów: powolne i niejasne',
    with: 'Mierzalne postępy · Wyraźny rozwój',
  },
  {
    without: 'Rodzice pytają „Gdzie są efekty?”',
    with: 'Gotowe arkusze ocen i raporty postępów',
  },
  {
    without: 'Wchodzenie na zajęcia bez przygotowania',
    with: 'Każda sesja rozpisana · Gotowy do uczenia',
  },
]
export const problems: string[] = [
  'Co tydzień spędzasz ponad 3 godziny na tworzeniu planów lekcji od zera',
  'Brakuje Ci pomysłów i w kółko powtarzasz te same ćwiczenia',
  'Nie wiesz, jak ułożyć logiczną progresję na cały rok',
  'Uczniowie rezygnują, bo nie widzą jasnej ścieżki rozwoju',
  'Przed każdymi zajęciami czujesz się nieprzygotowany i zestresowany',
  'Zamieniasz swoją kreatywną energię na wypalenie papierkową robotą',
]
